import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchText: "",
  categories: [],
  selectedCategories: {},
  symptoms: [],
  diseases: [],
  /****/
  selectedSymptoms: [],
  symptomsToRemove: [],
  displayedSymptoms: [],
  symptomsSelectedToRemove: [],
  /****/
  selectedDiseases: [],
  diseasesToRemove: [],
  displayedDiseases: [],
  diseasesSelectedToRemove: [],
  /****/
  selectedFamilyBackgrounds: [],
  familyBackgroundsToRemove: [],
  displayedFamilyBackgrounds: [],
  familyBackgroundsSelectedToRemove: [],
  /****/
  selectedPatientBackgrounds: [],
  patientBackgroundsToRemove: [],
  displayedPatientBackgrounds: [],
  patientBackgroundsSelectedToRemove: [],
  /****/
  symptomsPageSize: null,
  totalSymptoms: null,
  diseasesPageSize: null,
  totalDiseases: null,
  totalPatients: null,
};

export const searchOmimSlice = createSlice({
  name: "searchOmim",
  initialState,
  reducers: {
    changeSelectedCategoriesAction: (state, action) => {
      state.selectedCategories = action.payload;
    },
    changeCategoriesAction: (state, action) => {
      state.categories = action.payload;
    },
    changeDiseasesAction: (state, action) => {
      state.diseases = action.payload;
    },
    changeSelectedDiseasesAction: (state, action) => {
      state.selectedDiseases = action.payload;
    },
    changeDiseasesToRemoveAction: (state, action) => {
      state.diseasesToRemove = action.payload;
    },
    changeDiseasesSelectedToRemoveAction: (state, action) => {
      state.diseasesSelectedToRemove = action.payload;
    },
    changeDisplayedDiseasesAction: (state, action) => {
      state.displayedDiseases = action.payload;
    },
    changeSearchTextAction: (state, action) => {
      state.searchText = action.payload;
    },
    changeSelectedSymptomsAction: (state, action) => {
      state.selectedSymptoms = action.payload;
    },
    changeSymptomsToRemoveAction: (state, action) => {
      state.symptomsToRemove = action.payload;
    },
    changeSymptomsSelectedToRemoveAction: (state, action) => {
      state.symptomsSelectedToRemove = action.payload;
    },
    changeSymptomsAction: (state, action) => {
      state.symptoms = action.payload;
    },
    changeSelectedPatientBackgroundsAction: (state, action) => {
      state.selectedPatientBackgrounds = action.payload;
    },
    changePatientBackgroundsToRemoveAction: (state, action) => {
      state.patientBackgroundsToRemove = action.payload;
    },
    changePatientBackgroundsSelectedToRemoveAction: (state, action) => {
      state.patientBackgroundsSelectedToRemove = action.payload;
    },
    changeDisplayedSymptomsAction: (state, action) => {
      state.displayedSymptoms = action.payload;
    },
    changeSelectedFamilyBackgroundsAction: (state, action) => {
      state.selectedFamilyBackgrounds = action.payload;
    },
    changeFamilyBackgroundsToRemoveAction: (state, action) => {
      state.familyBackgroundsToRemove = action.payload;
    },
    changeFamilyBackgroundsSelectedToRemoveAction: (state, action) => {
      state.familyBackgroundsSelectedToRemove = action.payload;
    },
    changeDisplayedFamilyBackgroundsAction: (state, action) => {
      state.displayedFamilyBackgrounds = action.payload;
    },
    changeDisplayedPatientBackgroundsAction: (state, action) => {
      state.displayedPatientBackgrounds = action.payload;
    },
    changeSymptomsPageSizeAction: (state, action) => {
      state.symptomsPageSize = action.payload;
    },
    changeTotalSymptomsAction: (state, action) => {
      state.totalSymptoms = action.payload;
    },
    changeDiseasesPageSizeAction: (state, action) => {
      state.diseasesPageSize = action.payload;
    },
    changeTotalDiseasesAction: (state, action) => {
      state.totalDiseases = action.payload;
    },
    changeTotalPatientsAction: (state, action) => {
      state.totalPatients = action.payload;
    },
    storeSearchInitialStateActionCreator: (state) => {
      return initialState;
    },
    cancelPatientSymptomsAction: (state, action) => {
      state.selectedSymptoms = [];
      state.symptomsToRemove = [];
      state.displayedSymptoms = action.payload;
    },
    cancelFamilyBackgroundsAction: (state, action) => {
      state.selectedFamilyBackgrounds = [];
      state.familyBackgroundsToRemove = [];
      state.displayedFamilyBackgrounds = action.payload;
    },
    cancelPatientBackgroundsAction: (state, action) => {
      state.selectedPatientBackgrounds = [];
      state.patientBackgroundsToRemove = [];
      state.displayedPatientBackgrounds = action.payload;
    },
    cancelPatientDiseasesAction: (state, action) => {
      state.selectedDiseases = [];
      state.diseasesToRemove = [];
      state.displayedDiseases = action.payload;
    },
    resetSelectionAction: (state, action) => {
      state.selectedCategories = {};
      state.selectedSymptoms = [];
      state.symptomsToRemove = [];
      state.selectedFamilyBackgrounds = [];
      state.familyBackgroundsToRemove = [];
      state.selectedPatientBackgrounds = [];
      state.patientBackgroundsToRemove = [];
      state.selectedDiseases = [];
      state.diseasesToRemove = [];
    },
  },
});

export const {
  changeCategoriesAction,
  changeSelectedCategoriesAction,
  changeDiseasesAction,
  changeSearchTextAction,
  changeSelectedSymptomsAction,
  changeSymptomsAction,
  changeDiseasesPageSizeAction,
  changeSymptomsPageSizeAction,
  changeTotalDiseasesAction,
  changeTotalSymptomsAction,
  changeSelectedDiseasesAction,
  changeSymptomsToRemoveAction,
  changeDiseasesToRemoveAction,
  changeSelectedFamilyBackgroundsAction,
  changeFamilyBackgroundsToRemoveAction,
  changeDisplayedSymptomsAction,
  changeDisplayedFamilyBackgroundsAction,
  changeDisplayedDiseasesAction,
  changeDisplayedPatientBackgroundsAction,
  storeSearchInitialStateActionCreator,
  cancelPatientSymptomsAction,
  cancelFamilyBackgroundsAction,
  cancelPatientDiseasesAction,
  resetSelectionAction,
  changeTotalPatientsAction,
  changeSelectedPatientBackgroundsAction,
  changePatientBackgroundsToRemoveAction,
  cancelPatientBackgroundsAction,
  /**/
  changeSymptomsSelectedToRemoveAction,
  changePatientBackgroundsSelectedToRemoveAction,
  changeFamilyBackgroundsSelectedToRemoveAction,
  changeDiseasesSelectedToRemoveAction,
} = searchOmimSlice.actions;

export const {
  diseases,
  selectedDiseases,
  diseasesToRemove,
  categories,
  selectedCategories,
  searchText,
  symptoms,
  symptomsPageSize,
  totalSymptoms,
  diseasesPageSize,
  totalDiseases,
  selectedSymptoms,
  symptomsToRemove,
  selectedFamilyBackgrounds,
  familyBackgroundsToRemove,
  displayedSymptoms,
  displayedFamilyBackgrounds,
  displayedDiseases,
  selectedPatientBackgrounds,
  patientBackgroundsToRemove,
  displayedPatientBackgrounds,
  totalPatients,
  /**/
  symptomsSelectedToRemove,
  diseasesSelectedToRemove,
  familyBackgroundsSelectedToRemove,
  patientBackgroundsSelectedToRemove,
} = searchOmimSlice.reducer;
export default searchOmimSlice.reducer;
